import runewordList from "@/assets/diablo2/data/runeword.json";

const state = () => ({
  runewordList: runewordList,
});

const getters = {};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions: {},
  modules: {},
};
